import React from 'react';

const NoGas = props => (
  <svg
    width={37}
    height={38}
    fill="none"
    viewBox="0 0 37 38"
    preserveAspectRatio="xMidYMid"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M16.657 19.597c.88.555 1.685 1.669 1.685 2.811 0 .937-.39 1.882-1.01 2.458-.517-.48-.907-1.36-1.013-2.109-1.684.82-2.694 2.69-2.694 4.57 0 2.716 2.113 4.92 4.718 4.92 2.61 0 4.722-2.202 4.722-4.92 0-3.799-2.863-7.112-6.406-7.73h-.002Z"
      stroke="#BCC6CA"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M14.997 4c1.98 1.25 3.794 3.758 3.794 6.327 0 2.104-.88 4.233-2.276 5.533-1.16-1.085-2.038-3.062-2.276-4.744-3.789 1.84-6.07 6.047-6.07 10.279 0 6.114 4.757 11.068 10.622 11.068s10.62-4.954 10.62-11.068c0-8.55-6.444-16.007-14.414-17.395Z"
      stroke="#BCC6CA"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.96 34 33.272 4.338" stroke="#647A85" strokeWidth={5.04} strokeLinecap="square" />
    <path d="M3.96 34 33.272 4.338" stroke="#BCC6CA" strokeLinecap="square" />
  </svg>
);

export default NoGas;
